import { IComboBoxOption, Panel, PanelType } from '@fluentui/react';
import React, { useState, useCallback, useEffect } from 'react';
import { PanelHeader } from '../../../../components/Panel/PanelHeader';
import { PanelFooter } from '../../../../components/Panel/PanelFooter';
import { ComboBoxComponent } from '../../../../components/comboBox/ComboBoxComponent';
import { UseComboRazon } from "../../../../hooks/auxiliar/combo/UseComboRazon";
import { UseComboTurno } from '../../../../hooks/auxiliar/combo/UseComboTurno';
import { UseComboUbicacion } from '../../../../hooks/auxiliar/combo/UseComboUbicacion';
import { UseComboEquipo } from '../../../../hooks/auxiliar/combo/UseComboEquipo';
import { IFilter2, IT, keyType, textType, } from '../UseEquipo';
import { UseComboGeneric } from '../../../../hooks/hazard/combo/UseComboGeneric';
import TipoEquipoService from '../../../../services/ListaVerificacion/TipoEquipoService';
import { IFilterTipoEquipo } from '../../../../Interfaces/ListaVerificacion/TipoEquipo/ITIpoEquipo';
import { useComboTipoEquipos } from '../../../../hooks/auxiliar/combo/UseComboTipoEquipo';

export interface IPanelEquipo {
    filter2: IFilter2;
    isOpen: boolean;
    equipoAuxiliar?: boolean,
    onChangeComboFilter: (data: IT) => void
    resetFilter2: () => void;
    buscar: () => void;
    onDismiss: () => void;
}

interface IR {
    data?: IComboBoxOption,
    key: keyType,
    text: textType
}
export const PanelEquipoFil = ({
    isOpen,
    resetFilter2,
    onChangeComboFilter,
    equipoAuxiliar,
    filter2,
    buscar,
    onDismiss
}: IPanelEquipo) => {

    const { dataComboRazon, onChange } = UseComboRazon(isOpen);
    const { dataComboTurno, onChangeTurno } = UseComboTurno(isOpen);
    const { dataComboUbicacion } = UseComboUbicacion({ comboNivel: 3, isOpen: isOpen });
    const { dataComboEquipo, onChangeEquipo } = UseComboEquipo({ isOpen, equipoAuxiliar: true });
    const { dataComboTipoE, onChangeTipoE } = useComboTipoEquipos({ isOpen, equipoAuxiliar: true });

  
    const handleOnChange = ({ data, key, text }: IR) => {
        if (data) {
            onChangeComboFilter({
                key,
                keyValue: `${data.key}`,
                text,
                textValue: data.text
            })
        }
    };
    useEffect(()=>{
        console.log(filter2)
    },[filter2])

    return (
        <Panel
            type={PanelType.smallFixedFar}
            onRenderHeader={() =>
                <PanelHeader
                    textHeader={`Equipos Auxiliares`}
                    subTextHeader={`Búsqueda Avanzada`}
                />
            }
            onRenderFooter={() =>
                <PanelFooter
                    texto="Buscar"
                    texto2={"Limpiar"}
                    onClick={buscar}
                    disableButton={false}
                    onDismiss={resetFilter2}
                />
            }
            isFooterAtBottom
            isOpen={isOpen}
            onDismiss={onDismiss}
        >
            <div className="ms-Grid" dir="ltr">
                <ComboBoxComponent
                    text="Razón:"
                    selectedKey={filter2.razonKey}
                    placeholder="Seleccione una Razón"
                    value={filter2.razonText}
                    onChange={onChange}
                    onOptionSelect={(event, option) => {
                        handleOnChange({
                            data: option,
                            key: 'razonKey',
                            text: 'razonText'
                        })
                    }}
                    defaultSelectedOptions={[{
                        key: filter2.razonKey,
                        text: filter2.razonText
                    }]}
                    data={dataComboRazon}
                />
                <ComboBoxComponent
                    text="Turno:"
                    selectedKey={filter2.turnoKey}
                    placeholder="Seleccione un Turno"
                    value={filter2.tuernoText}
                    onChange={onChangeTurno}
                    onOptionSelect={(event, option) => {
                        handleOnChange({
                            data: option,
                            key: 'turnoKey',
                            text: 'tuernoText'
                        })
                    }}
                    defaultSelectedOptions={[{
                        key: filter2.turnoKey,
                        text: filter2.tuernoText
                    }]}
                    data={dataComboTurno}
                />
                <ComboBoxComponent
                    text={"Ubicación"}
                    placeholder="Seleccione una Ubicación"
                    selectedKey={filter2.ubicacionKey}
                    onChange={onChangeEquipo}
                    value={filter2.ubicacionText}
                    onOptionSelect={(event, option) => {
                        handleOnChange({
                            data: option,
                            key: 'ubicacionKey',
                            text: 'ubicacionText'
                        })
                    }}
                    defaultSelectedOptions={[{
                        key: filter2.ubicacionKey,
                        text: filter2.ubicacionText
                    }]}
                    data={dataComboUbicacion}
                />
                <ComboBoxComponent
                    text="Equipo:"
                    selectedKey={filter2.equipoKey}
                    placeholder="Seleccione un Equipo"
                    value={filter2.equipoText}
                    onChange={onChangeEquipo}
                    onOptionSelect={(event, option) => {
                        handleOnChange({
                            data: option,
                            key: 'equipoKey',
                            text: 'equipoText'
                        })
                    }}
                    defaultSelectedOptions={[{
                        key: filter2.equipoKey,
                        text: filter2.equipoText
                    }]}
                    data={dataComboEquipo}
                />
                <ComboBoxComponent text={'Tipo Equipo'}
                  selectedKey={filter2.tipoEquipoKey}
                  placeholder="Seleccione un Tipo de Equipo"
                  value={filter2.tipoEquipoText}
                  onChange={(value) => {
                    onChangeTipoE(value)
                  }}
                  defaultSelectedOptions={[{
                    key: filter2.tipoEquipoKey,
                    text: filter2.tipoEquipoText
                }]}
                  onOptionSelect={(event, option) => {
                    handleOnChange({
                        data: option,
                        key: 'tipoEquipoKey',
                        text: 'tipoEquipoText'
                    })
                }}
                data={dataComboTipoE}/>
            </div>
        </Panel>
    );
};
